import {HelpTip, Vertical, Horizontal, LightBulbIcon} from '@taopix/taopix-design-system';
import React, {useEffect} from 'react';
import {useTranslation} from 'react-i18next';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {useExperience} from '../Experience/ExperienceProvider';
import {useUserFlowState} from '../Context/UserFlow/UserFlowContext';
import {UserInterfaceActions} from '../Context/UserInterface/UserInterfaceActionTypes';

const ToolPaletteIntroTip = () => {
  const {t} = useTranslation();
  const ui = useUiState();
  const {experience} = useExperience();
  const userFlow = useUserFlowState();
  const activeUserFlowStagesCount = userFlow.getActiveStages().length;

  let tipMessage = '';
  const canUploadPictures =
    (experience.EDITOR.pictures.picturePalette && experience.EDITOR.pictures.addPicturesButton) ||
    experience.EDITOR.toolPalette.showAddPicturesButton;
  const canApplyLayouts = experience.EDITOR.layouts.layoutsPalette;
  const canApplyBackgrounds = experience.EDITOR.backgrounds.backgroundsPalette;

  switch (true) {
    case canUploadPictures && canApplyLayouts && canApplyBackgrounds:
      // All palettes available
      tipMessage = t('helptips:str_MessageUseTheToolbarAllPalettes');
      break;
    case canUploadPictures && canApplyLayouts && !canApplyBackgrounds:
      // Only Pictures & Layouts
      tipMessage = t('helptips:str_MessageUseTheToolbarPicturesAndLayouts');
      break;
    case canUploadPictures && !canApplyLayouts && canApplyBackgrounds:
      // Only Pictures & Backgrounds
      tipMessage = t('helptips:str_MessageUseTheToolbarPicturesAndBackgrounds');
      break;
    case !canUploadPictures && canApplyLayouts && canApplyBackgrounds:
      // Only Layouts and Backgrounds
      tipMessage = t('helptips:str_MessageUseTheToolbarLayoutsAndBackgrounds');
      break;
    case canUploadPictures && !canApplyLayouts && !canApplyBackgrounds:
      // Only Pictures
      tipMessage = t('helptips:str_MessageUseTheToolbarPicturesOnly');
      break;
    case !canUploadPictures && canApplyLayouts && !canApplyBackgrounds:
      // Only Layouts
      tipMessage = t('helptips:str_MessageUseTheToolbarLayoutsOnly');
      break;
    case !canUploadPictures && !canApplyLayouts && canApplyBackgrounds:
      // Only Backgrounds
      tipMessage = t('helptips:str_MessageUseTheToolbarBackgroundsOnly');
      break;
  }

  useEffect(() => {
    // Open the tip when the user enters the editor
    if (activeUserFlowStagesCount === 1 && tipMessage !== '') {
      ui.dispatch(UserInterfaceActions.setTipOpen({name: 'toolPaletteIntro', open: true}));
    }
  }, [activeUserFlowStagesCount]);

  useEffect(() => {
    // Close this tip if a palette has been opened
    if (ui.state.palette.section !== null) {
      ui.dispatch(UserInterfaceActions.setTipOpen({name: 'toolPaletteIntro', open: false}));
    }
  }, [ui.state.palette.section]);

  return (
    <HelpTip
      open={ui.state.tips.toolPaletteIntro}
      id={'toolPaletteIntroTip'}
      title={'Tip'}
      titleIcon={<LightBulbIcon />}
      message={tipMessage}
      buttonLabel={t('*:str_ButtonClose')}
      buttonFunction={() =>
        ui.dispatch(UserInterfaceActions.setTipOpen({name: 'toolPaletteIntro', open: false}))
      }
      anchorId={ui.state.isSmallScreen ? 'toolpalette' : 'tool-palette__group-two'}
      anchorOrigin={
        ui.state.isSmallScreen
          ? {vertical: Vertical.Top, horizontal: Horizontal.Centre}
          : {vertical: Vertical.Middle, horizontal: Horizontal.Right}
      }
      transformOrigin={
        ui.state.isSmallScreen
          ? {vertical: Vertical.Bottom, horizontal: Horizontal.Centre}
          : {vertical: Vertical.Middle, horizontal: Horizontal.Left}
      }
      offset={ui.state.isSmallScreen ? {x: 0, y: -5} : {x: 10, y: 0}}
      arrow
      showAfter={1000}
      showMode={'once'}
      contentWidth={ui.state.isSmallScreen ? 400 : 300}
    />
  );
};

export default ToolPaletteIntroTip;
